import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/account.js';
import {auth, generateUserDocument} from "../../components/firebase/fbApp";


function RegisterMail(props) {

    const [displayName, setDisplayName] = useState("");

    const setVerifyDevice = (id) => {
        localStorage.setItem("Verification", id);
        console.log("set", id)
    }

    const createUserWithEmailAndPasswordHandler = async ( email, password) => {
        const error = document.getElementById("error");
        try{
            console.log("start registration",password,email)
            const {user} = await auth.createUserWithEmailAndPassword(email, password)
                .then((res)=>{
                    console.log(res,"res")
                    error.innerText = "";
                    return res
                })
                .catch((res)=> {
                    console.log(res)
                    if(res.status === 400){
                        error.innerText = res;
                        throw res
                    }
                })
            const date = Date.now();
            console.log(user,displayName)
            generateUserDocument(user,user.uid,date);
            setVerifyDevice(user.uid)
            window.location = "/"

        }
        catch(error){
            throw error
        }
    };

    useEffect(() => {
        const form = document.getElementById("form_registration");
        const email = document.getElementById("registration_email");
        const user = document.getElementById("registration_user");
        const password = document.getElementById("registration_password");
        const cpassword = document.getElementById("registration_cpassword");

        form.addEventListener("submit", formSubmit);

        function formSubmit(e) {
            e.preventDefault();

            const emailValue = email.value.trim();
            const userValue = user.value.trim();
            const passwordValue = password.value.trim();
            const cpasswordValue = cpassword.value.trim();
            setDisplayName(userValue)


            if (emailValue === "") {
                setError(email, "Email can't be blank");
            } else if (!isEmail(emailValue)) {
                setError(email, "Not a valid email");
            } else {
                setSuccess(email);
            }

            if (userValue === "") {
                setError(user, "User name can't be blank");
            } else {
                setSuccess(user);
            }

            if (passwordValue === "") {
                setError(password, "Password can't be blank");
            } else {
                setSuccess(password);
            }

            if (cpasswordValue === "" || passwordValue !== cpasswordValue) {
                setError(cpassword, "Password doesn't match");
            } else {
                createUserWithEmailAndPasswordHandler(emailValue,cpasswordValue)
                    .then(setSuccess(cpassword))
                    .catch((res)=>{
                        setError(document.getElementById("registration_password"), res);
                    })
                props.history.push("/");

            }
        }

        function setError(input, message) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".registration_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        function setSuccess(input) {
            const formControl = input.parentElement;
            formControl.className = "form-control success";
        }

        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }
    });

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper registration-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcroumb */}
                <BreadcrumbBox title="Registration" />

                {/* Registration Area */}
                <section className="registration-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="registration-box">
                                    <div className="registration-title text-center">
                                        <h3>Registration</h3>
                                    </div>
                                    <form id="form_registration" className="form">

                                        <p className="form-control">
                                            <label htmlFor="registration_email" name="email">Email Address</label>
                                            <input type="email" placeholder="Email address" id="registration_email" />
                                            <span className="registration_input-msg"></span>
                                        </p>
                                        <p className="form-control">
                                            <label htmlFor="registration_user" name="displayName">User Name</label>
                                            <input type="text" placeholder="Username" id="registration_user" />
                                            <span className="registration_input-msg"></span>
                                        </p>
                                        <p className="form-control">
                                            <label htmlFor="registration_password" name="password">Password</label>
                                            <input type="password" placeholder="*******" id="registration_password" />
                                            <span className="registration_input-msg"></span>
                                        </p>
                                        <p className="form-control">
                                            <label htmlFor="registration_cpassword">Confirm Password</label>
                                            <input type="password" placeholder="Confirm password" id="registration_cpassword" />
                                            <span className="registration_input-msg"></span>
                                        </p>
                                        <div id="error"></div>
                                        <button>Register Now</button>
                                    </form>

                                    <div className="have_account-btn text-center">
                                        <p>Already have an account? <Link to="/login">Login Here</Link></p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    )
}

export default RegisterMail